import script from "./BaseListElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseListElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./BaseListElementLite.vue?vue&type=style&index=0&id=4b983f56&lang=scss&scoped=true"
import "./BaseListElementLite.vue?vue&type=style&index=1&id=4b983f56&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b983f56"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
